import { useState } from "react";
import { faqs } from "@/mocks/heigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-cream-100 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="mb-3 inline-flex items-center gap-2 text-xs font-medium tracking-[0.25em] text-ember-600">
            <span className="h-px w-8 bg-ember-500" />
            TRUST & FAQ
            <span className="h-px w-8 bg-ember-500" />
          </p>
          <h2 className="font-serif text-2xl font-bold tracking-tight text-ink-950 md:text-4xl">
            先问清楚，再放心吃
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-ink-600 md:text-base">
            关于吃瓜黑屋的立场、私密分享规则与加密专区的常见疑问，我们在这页一次讲明白。
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const active = openIdx === i;
            return (
              <div
                key={i}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  active ? "border-ember-200 bg-white" : "border-cream-200 bg-white/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(active ? -1 : i)}
                  className="flex w-full items-center gap-4 px-5 py-5 text-left"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
                      active ? "bg-ember-500 text-cream-50" : "bg-cream-200 text-ink-700"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 text-sm font-semibold text-ink-950 md:text-base">{item.q}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-ink-600 transition-transform duration-300 ${
                      active ? "rotate-180 text-ember-600" : ""
                    }`}
                  />
                </button>
                {active && (
                  <div className="px-5 pb-5">
                    <div className="ml-12 border-l-2 border-cream-200 pl-4">
                      <p className="text-sm leading-relaxed text-ink-600 md:text-[15px]">{item.a}</p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}